import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import useStateRef from "react-usestateref";
import EventEmitter from "src/utils/EventEmitter";
import axios from "axios";
import { useSnackbar } from "notistack";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { CloseSnackbarAction } from "src/components/CloseSnackbarAction";
import OutsideClickHandler from "react-outside-click-handler";
import { getCartSecretList } from "src/utils/ActiveCartSecret";
import { CheckExpiredToken } from "src/components/CheckeExpiredToken";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';

import "./navbar.css";

const NavBar = (props) => {
  /* eslint-disable */
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [showProfile, setShowProfile, showProfileRef] = useStateRef(false);
  const { company, userProfile } = props;
  const userName = userProfile.partner.name

  const isImpersonate = localStorage.getItem("impersonate-token") ? true : false;

  const onClickLogo = () => {
    navigate('/');
  };

  const showProfilePopup = () => {
    setShowProfile(!showProfileRef.current);
  };

  const onLogout = () => {
    EventEmitter.emit("show_notification", { value: true, type: "logout" });
  };

  const clickAccount = () => {
    return
    navigate("/accounts");
    EventEmitter.emit("show_full", { value: false });
    setShowProfile(false);
    EventEmitter.emit("show_top_navigation", { value: false });
  };

  const loginAsCustomer = () => {
    setShowProfile(false);
    EventEmitter.emit("show_full", { value: true });
    EventEmitter.emit("show_notification", {
      value: true,
      type: "login-as-customer",
    });
  };

  const logoutAsCustomer = () => {
    localStorage.removeItem("impersonate-token");

    enqueueSnackbar(`You have successfully logged out as customer`, { variant: 'success', onClose: () => window.location.href = "/" });
  }

  return (
    <>
      <div className="navbar-content-top-desktop">
        <div className="navbar-content-desktop-top-container">
          <div className="navbar-content-desktop-top-wrapper">
            <div className="navbar-left-wrapper">
              <div
                className="navbar-left-logo-wrapper"
                style={{ cursor: "pointer" }}
                onClick={() => onClickLogo()}
              >
                <div>
                  <img
                    className="navbar-left-logo"
                    src={`/static/images/consignment.png`}
                    alt="greenship_logo"
                  />
                </div>
                <div className="logo-divider"></div>
                <div className="logo-text">Consignment Portal</div>
              </div>
            </div>
            <div className="navbar-right-wrapper">

              <OutsideClickHandler
                key={1}
                onOutsideClick={() => {
                  setShowProfile(false);
                }}
              >
                <div
                  className="navbar-right-profile-icon"
                  onClick={() => showProfilePopup()}
                >
                  <div className="name">{userName}</div>
                  <img
                    src="/static/images/icon/user_icon.svg"
                    alt="profile_image"
                  />
                  <img className="dropdown-icon" src={"/static/images/icon/dropdown.svg"} alt="dropdown" />
                </div>

                {showProfileRef.current ? (
                  <div className={`profile_popup`}>
                    <div className="profile_popup_wrapper">
                      <div
                        className={`profile_popup_item`}
                        onClick={() => clickAccount()}
                      >
                        <div className="profile_popup_icon">
                          <img
                            src="/static/images/icon/empty_avatar_profile.svg"
                            alt="profile_icon"
                          />
                        </div>
                        <div className="profile_popup_text">Account</div>
                      </div>
                      {props.userProfile?.canImpersonate && !isImpersonate ? (
                        <>
                          <div className="profile_divider"></div>
                          <div
                            className={`profile_popup_item`}
                            style={{ paddingBottom: "8px", paddingTop: "8px" }}
                            onClick={() => loginAsCustomer()}
                          >
                            <AdminPanelSettingsOutlinedIcon />
                            <div className="profile_popup_text">
                              Login as Customer
                            </div>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      {isImpersonate ? (
                        <>
                          <div className="profile_divider"></div>

                          <div
                            className={`profile_popup_item`}
                            style={{ paddingBottom: "8px", paddingTop: "8px" }}
                            onClick={() => logoutAsCustomer()}
                          >
                            <ExitToAppIcon />
                            <div className="profile_popup_text">
                              Log out as Customer
                            </div>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      <div className="profile_divider"></div>
                      <div
                        className="profile_popup_item"
                        onClick={() => onLogout()}
                      >
                        <div className="profile_popup_icon">
                          <img
                            src="/static/images/logout_icon.svg"
                            alt="logout_icon"
                          />
                        </div>
                        <div className="profile_popup_text logout">Log out</div>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </OutsideClickHandler>
            </div>
          </div>
        </div>
      </div>
      <div className="extra-navbar-wrapper">
        <div className="extra-navbar-container">
          <div className="extra-navbar-title">{userName}</div>
          {company && <div className="extra-navbar-place">{company}</div>}
        </div>
      </div>
      <>
        <div className="navbar-content-mobile-top">
          <div className="navbar-content-mobile-top-wrapper">
            <div
              className="navbar-left-icon-wrapper"
              style={{ cursor: "pointer" }}
              onClick={() => onClickLogo()}
            >
              <div
                className="navbar-left-logo-wrapper"
                style={{ cursor: "pointer" }}
                onClick={() => onClickLogo()}
              >
                <div>
                  <img
                    className="navbar-left-logo"
                    src={`/static/images/consignment.png`}
                    alt="greenship_logo"
                  />
                </div>
                <div className="logo-divider"></div>
                <div className="logo-text">Consignment Portal</div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

NavBar.propTypes = {
  onMobileNavOpen: PropTypes.func,
};

NavBar.defaultProps = {
  onMobileNavOpen: () => { },
};

export default NavBar;
